<script lang="ts">
	import { fetchDataVarious, is_2nd_store, publicDataFetch, timer, Toast } from '../scripts/util';
	import MainLayout from '../layouts/MainLayout.svelte';
	import { ArrowRightBold, CloseIcon, EmailArrowRight, InformationOutline, Plus, QuestionCircleOutline, SearchIcon } from '../icons';
	import { push } from 'svelte-spa-router';
	import { Color } from '../scripts/color';
	import LoadingCube from '../components/LoadingCube.svelte';
	import { checkDigit } from '../scripts/vin_check_digit_check';
	import { fade } from 'svelte/transition';
	import { onMount, tick } from 'svelte';
	import Swal from 'sweetalert2/dist/sweetalert2.js';

	import AnalysisCarResult from '../components/AnalysisCarResult.svelte';
	import AnalysisPartsResult from '../components/AnalysisPartsResult.svelte';
	const contact_mail_address = import.meta.env.VITE_CONTACT_MAIL_ADDRESS;
	const parts_scrip_page = import.meta.env.VITE_SCRIP_BASE_LINK;
	const add_prefix = is_2nd_store ? '-alt' : '';

	if (location.pathname.includes('login')) {
		// location.assign('/#/login');
		push('/login');
	}
	if (location.pathname.includes('admin')) {
		push('/admin');
	}
	const local_storage_key = 'search-history';

	let input_vin_number = '';
	let item_codes = [
		{
			code: '',
			found: null,
			name: '',
			adapted: false,
		},
	];

	let search_status = {
		vehicle: {
			searched: false,
			searching: false,
			search_historys: [],
			search_validations: [],
		},
		parts: {
			searched: false,
			searching: false,
			search_validations: [],
		},
	};

	let result_vehicle: type_service_search_result = {
		messages: [],
		analysis: null,
		search_resolved: false,
		conformity_searched: false,
		input_vin_number: '',
	};

	let result_parts: type_service_search_result = {
		messages: [],
		analysis: null,
		search_resolved: false,
		conformity_searched: false,
		input_vin_number: '',
	};

	let active_section_no = 1;
	let expanded_second_section = false;

	async function searchVehicle() {
		search_status.vehicle.searched = true;
		search_status.vehicle.searching = true;
		result_vehicle = {
			messages: [],
			analysis: null,
			search_resolved: false,
			conformity_searched: false,
			input_vin_number: '',
		};
		result_parts = {
			messages: [],
			analysis: null,
			search_resolved: false,
			conformity_searched: false,
			input_vin_number: '',
		};
		search_status.parts.searched = false;
		const params: any = {
			vin_number: input_vin_number
				.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s: string) {
					return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
				})
				.toUpperCase(),
		};
		if (developer_mode) {
			params.statistics_off = 1;
		}
		try {
			const data: type_service_search_result = await publicDataFetch('search/vehicle', params);

			search_status.vehicle.search_validations = [];
			if (data.input_vin_number.length > 0) {
				if (search_status.vehicle.search_historys.length === 0 || search_status.vehicle.search_historys[0] !== data.input_vin_number) {
					if (search_status.vehicle.search_historys.length > 10) {
						search_status.vehicle.search_historys.pop();
					}
					search_status.vehicle.search_historys.unshift(data.input_vin_number);
					search_status.vehicle.search_historys = search_status.vehicle.search_historys;
					saveSearchHistory();
				}
				const digit_checker = checkDigit(data.input_vin_number);
				if (!digit_checker) {
					// data.messages.push('入力されたVINナンバーは、正しくない可能性があります。今一度ご確認ください。');
					data.messages = ['入力されたVINナンバーは、正しくない可能性があります。今一度ご確認ください。'];
				} else {
					active_section_no = 2;
				}
				input_vin_number = data.input_vin_number;
			}
			result_vehicle = {
				...data,
			};
		} catch (e) {
			if (e.status === 422) {
				// search_status.vehicle.search_validations = [];
				// for (const key in e.data.errors) {
				// 	search_status.vehicle.search_validations.push(...e.data.errors[key]);
				// }
				// search_status.vehicle.search_validations = search_status.vehicle.search_validations;

				search_status.vehicle.search_validations = ['入力されたVINナンバーは、正しくない可能性があります。今一度ご確認ください。'];
			} else {
				// search_status.vehicle.search_validations = [];
				search_status.vehicle.search_validations = [];
			}
		} finally {
			search_status.vehicle.searching = false;
		}
	}

	async function searchParts() {
		if (is_2nd_store && (!search_status.vehicle.searched || !result_vehicle.search_resolved)) {
			// 2号店かつ、車両検索できていない
			Swal.fire({
				text: '17桁のシリアルナンバーを入力してください。',
				icon: 'error',
			});
			// Toast.error('適合確認の前に、①で17桁のシリアルナンバーを入力し、車両をご確認ください。');
		}

		search_status.parts.searched = true;
		search_status.parts.searching = true;
		// await timer(1000);
		result_parts = {
			messages: [],
			analysis: null,
			search_resolved: false,
			conformity_searched: false,
		};
		const params: any = {
			vin_number: result_vehicle.input_vin_number,
			item_codes: item_codes.map(row => row.code.toUpperCase()).filter(code => code && code.length > 0),
		};
		try {
			const data: type_service_search_result = await publicDataFetch('search/parts', params);

			search_status.parts.search_validations = [];

			result_parts = {
				...data,
			};
			item_codes = data.analysis.item_inputs;
			if (item_codes.length > 0) {
				active_section_no = 3;
			}
		} catch (e) {
			if (e.status === 422) {
				search_status.parts.search_validations = [];
				for (const key in e.data.errors) {
					search_status.parts.search_validations.push(...e.data.errors[key]);
				}
				search_status.parts.search_validations = search_status.parts.search_validations;
			} else {
				search_status.parts.search_validations = [];
			}
		} finally {
			search_status.parts.searching = false;
		}
	}

	async function plusItemInputRow() {
		item_codes.push({
			code: '',
			found: null,
			name: '',
			adapted: false,
		});
		item_codes = item_codes;
		await tick();
		if (item_codes.length > 0) {
			const i_element = document.getElementById(`input-item-code-${item_codes.length - 1}`);
			if (i_element) {
				i_element.focus();
			}
			active_section_no = 2;
		}
	}

	function delItemInputRow(index: number) {
		item_codes.splice(index, 1);
		item_codes = item_codes;
	}

	function autoInput(vin: string) {
		input_vin_number = vin;
	}

	async function bulkPaste() {
		item_codes = [];
		const read_board = await navigator.clipboard.readText();
		const board_to_array = read_board.split('\r\n');

		for (let i = 0; i < board_to_array.length; i++) {
			if (board_to_array[i].length !== 3) {
				Toast.warn('形式が正しくありません。');
				break;
			}
			if (!item_codes[i]) {
				plusItemInputRow();
			}
			item_codes[i].code = board_to_array[i];
		}

		item_codes = item_codes;
	}
	function saveSearchHistory() {
		const history_string = JSON.stringify(search_status.vehicle.search_historys);
		localStorage.setItem(local_storage_key, history_string);
	}

	function vehicleClear() {
		localStorage.removeItem(local_storage_key);
		result_vehicle = {
			messages: [],
			analysis: null,
			search_resolved: false,
			conformity_searched: false,
			input_vin_number: '',
		};
		input_vin_number = '';
		search_status.vehicle.searched = false;
		active_section_no = 1;
	}

	function itemCodesClear() {
		item_codes = [];
		result_parts = {
			messages: [],
			analysis: null,
			search_resolved: false,
			conformity_searched: false,
			input_vin_number: '',
		};
		search_status.parts.searched = false;
		active_section_no = 2;
	}

	function handleOnInputKeydown(event: KeyboardEvent, type: 'vehicle' | 'parts') {
		if (event.key === 'Enter') {
			if (type === 'vehicle') {
				active_section_no = 1;
				searchVehicle();
			}
			if (item_codes.some(c => c.code.length === 3 || (is_2nd_store && c.code.length === 4)) && search_status.vehicle.searched && result_vehicle.search_resolved && type === 'parts') {
				searchParts();
			}
			event.preventDefault();
			event.stopPropagation();
		} else if (type === 'parts' && event.key === '+') {
			plusItemInputRow();
			event.preventDefault();
			event.stopPropagation();
		}
	}

	let developer_mode = false;

	function handleWindowKeydown(event: KeyboardEvent) {
		if (event.ctrlKey && event.altKey && event.key === 'd') {
			developer_mode = !developer_mode;
		}
	}

	function expandSecondSection() {
		expanded_second_section = true;
	}

	let validation_vin = false;
	let validation_update_timer = null;
	let validated_vin_number = '';
	const reg = new RegExp(/^[\d|a-z|A-Z|\*|\-|#]+$/);
	$: {
		clearTimeout(validation_update_timer);
		validation_update_timer = setTimeout(() => {
			validation_vin = input_vin_number.length === 0 || input_vin_number.length === 17;
		}, 300);
		validated_vin_number = input_vin_number.length === 17 && reg.test(input_vin_number) ? input_vin_number : '';
	}

	onMount(() => {
		const l_p = new URLSearchParams(location.search);
		if (l_p.has('d')) {
			developer_mode = true;
		}

		const history_string = localStorage.getItem(local_storage_key);
		const history_array = JSON.parse(history_string ?? '[]');
		search_status.vehicle.search_historys = history_array;
		const reg = new RegExp(/^[\d|a-z|A-Z|\*|\-|#]+$/);
		if (
			search_status.vehicle.search_historys &&
			search_status.vehicle.search_historys.length > 0 &&
			search_status.vehicle.search_historys[0] &&
			search_status.vehicle.search_historys[0].length === 17 &&
			search_status.vehicle.search_historys[0] &&
			// 攻撃対策になるか
			reg.test(search_status.vehicle.search_historys[0])
		) {
			autoInput(search_status.vehicle.search_historys[0]);
			searchVehicle();
		}
	});
</script>

<svelte:window on:keydown={handleWindowKeydown} />

<MainLayout layout_class="home" {developer_mode}>
	<div class="home-wrapper">
		<!-- 入力フォーム -->
		<div class="inputter">
			<!-- <h2 class="annotation">セルフ適合検索</h2> -->
			<p class="top-message">VIN(シリアルナンバー)からパーツの適合を確認するシステムです。</p>

			<!-- 1. -->
			<section
				class="card vehicle-confirm-card"
				class:search-successed={!is_2nd_store && result_vehicle.search_resolved && result_vehicle.analysis.vehicle && result_vehicle.messages.length === 0}
				class:active-section={is_2nd_store && active_section_no === 1}
			>
				<div class="card-header fl">
					<label class="form-label h5 me-2" for="input-vin">①17桁のVIN(シリアルナンバー)を入力してください。</label>
					<div class="actions ms-auto">
						<button class="btn btn-outline{add_prefix}-error" type="button" on:click={vehicleClear}> 車種リセット </button>
					</div>
				</div>
				<div class="card-body">
					<form
						action="#"
						on:submit={() => {
							return false;
						}}
					>
						<div class="form-group" class:has-warn={!validation_vin}>
							<div class="input-group">
								<input
									class="form-input {add_prefix}  vin-input"
									class:is-warn={!validation_vin}
									type="text"
									id="input-vin"
									bind:value={input_vin_number}
									pattern="^[\da-zA-Z\*\-#]+$"
									required
									placeholder="VINナンバーを入力してください..."
									on:keydown={e => handleOnInputKeydown(e, 'vehicle')}
								/>
								<button class="btn btn{add_prefix}-sea round input-group-btn input-lg fl ps-1 pe-3" type="button" on:click={searchVehicle}>
									<SearchIcon size="1.3em" />
									<span>確認</span>
								</button>
							</div>

							{#if input_vin_number.length === 17 && validation_vin && !search_status.vehicle.searched}
								<p class="validation-hint form-input-hint {add_prefix} ps-1 fl">
									{#if !is_2nd_store}
										<InformationOutline size="1.5em" color={Color.sea} class="me-1" />
									{/if}
									<span>確認をクリックしてください。</span>
								</p>
							{/if}

							{#if search_status.vehicle.searched}
								{#if search_status.vehicle.searching}
									<LoadingCube />
								{:else}
									<hr />
									<div class="result-card" in:fade>
										{#if result_vehicle.search_resolved}
											<AnalysisCarResult analysis_result={result_vehicle} vin={input_vin_number} />
										{:else}
											<ul class="result-messages">
												{#each search_status.vehicle.search_validations as message}
													<li class="red">{message}</li>
												{/each}
											</ul>
										{/if}
									</div>
								{/if}
							{/if}
						</div>
					</form>
				</div>
			</section>

			{#if is_2nd_store}
				<button class="expand-switcher fl mt-5" on:click={expandSecondSection}>
					<ArrowRightBold size="1.5em" />
					<span>商品コードから適合を確認する</span>
				</button>
			{/if}

			<!-- 2. -->
			{#if !is_2nd_store || expanded_second_section}
				<section class="card mt-2 parts-search-card" in:fade class:active-section={is_2nd_store && active_section_no === 2}>
					<div class="card-header fl">
						<label class="form-label h5 me-2" for="input-part-number">②商品コードを入力し、適合確認ボタンを押してください。</label>
						<div class="actions ms-auto">
							{#if item_codes.length > 0}
								<button class="btn btn-outline{add_prefix}-error" type="button" on:click={itemCodesClear}> 商品コードリセット </button>
							{/if}
							{#if developer_mode}
								<button class="btn btn-gray pc-only" class:ms-2={item_codes.length > 0} class:ms-auto={item_codes.length === 0} type="button" on:click={bulkPaste}> 一括貼付 </button>
							{/if}
						</div>
					</div>
					<div class="card-body">
						<form>
							<div class="form-group mt-3 item-code">
								{#if item_codes.length === 0}
									<p class="mt-2 ms-08 mb-2">・「入力欄を追加」をクリックしてください。</p>
								{/if}
								<ol>
									{#each item_codes as code_row, i}
										{@const is_warn =
											(code_row.code.length !== 0 && code_row.code.length !== 3 && !(is_2nd_store && code_row.code.length === 4)) || (code_row.found !== null && !code_row.found)}
										<li>
											<div class="d-inline-flex item-code-input-row">
												<div class="form-group m-0" class:has-warn={is_warn}>
													<input
														class="form-input {add_prefix}  item-code-input"
														class:is-warn={is_warn}
														type="text"
														id={'input-item-code-' + i}
														bind:value={code_row.code}
														placeholder="AAA"
														pattern="^[a-zA-Z\d]+$"
														on:keydown={e => handleOnInputKeydown(e, 'parts')}
													/>
												</div>
												{#if !search_status.parts.searched && code_row.code.length !== 0 && code_row.code.length !== 3 && !(is_2nd_store && code_row.code.length === 4)}
													{@const input_char_hint = is_2nd_store ? '３文字、または４文字' : '３文字'}
													<p class="form-input-hint {add_prefix}  ms-2 mb-0">商品コードは{input_char_hint}を入力してください。</p>
												{/if}
												{#if code_row.found !== null}
													{#if code_row.found}
														<span class="ms-2">{code_row.name}</span>
													{:else}
														<p class="form-input-hint {add_prefix}  fl ms-2 mb-0">
															<QuestionCircleOutline size="1.5em" />
															<span class="ms-1">商品が見つかりませんでした。</span>
														</p>
													{/if}
												{/if}

												<button class="ms-auto btn btn-outline-gray round fl px-2" type="button" on:click={() => delItemInputRow(i)}>
													<CloseIcon size="1.2em" />
													<span>削除</span>
												</button>
											</div>
										</li>
									{/each}
								</ol>
							</div>
							{#if search_status.parts.search_validations.length > 0}
								<div class="form-group mt-2">
									<ul>
										{#each search_status.parts.search_validations as message}
											<li class="red">{message}</li>
										{/each}
									</ul>
								</div>
							{/if}
							<div class="form-group search fl j-c mt-3">
								<button class="btn btn-outline{add_prefix}-sea round plus" type="button" on:click={plusItemInputRow}>
									<div class="fl">
										<Plus size="1.3em" />
										<span>入力欄を追加</span>
									</div>
								</button>
								<button
									type="button"
									class="ms-3 btn btn{add_prefix}-primary round type-scale-up-mini fl j-c search"
									on:click={searchParts}
									disabled={!is_2nd_store && (!search_status.vehicle.searched || !result_vehicle.search_resolved)}
								>
									<SearchIcon size="1.7em" />
									<span class="ms-1">適合確認</span>
								</button>
							</div>
						</form>
					</div>
				</section>
			{/if}
		</div>

		<div class="original-divider" />

		{#if search_status.parts.searched}
			<div class="result-and-info mt-2 mb-4">
				<!-- 検索結果 -->
				<div class="result">
					{#if search_status.parts.searching}
						<LoadingCube />
					{:else}
						<div class="result-card card" in:fade class:active-section={is_2nd_store && active_section_no === 3}>
							{#if result_parts.search_resolved}
								<AnalysisPartsResult analysis_result={result_parts} vin={validated_vin_number} />
							{:else}
								<div class="card-body">
									<div class="adapted-info columns fl">
										<b class="h5">検索できませんでした。</b>
									</div>
									<ul class="result-messages">
										{#each result_parts.messages as message}
											<li>{message}</li>
										{/each}
									</ul>
								</div>
							{/if}
						</div>
					{/if}
				</div>
			</div>
		{/if}

		{#if is_2nd_store && !expanded_second_section}
			<p class="expand-switcher mt-3 mb-2 ms-5">もしくは</p>
		{/if}

		{#if is_2nd_store}
			<button class="expand-switcher mt-1">
				<a href={parts_scrip_page + validated_vin_number} target="_blank" class="fl" rel="noopener noreferrer">
					<p class="fl">
						<ArrowRightBold size="1.5em" />
						<span>お車に適合する商品を探す</span>
					</p>
					<img src="/partsscrip-link-miyazeki.png" alt="パーツチェッカーロゴ" class="pt-2" />
				</a>
			</button>
		{/if}

		{#if !is_2nd_store}
			<hr />

			<div class="contact-info mt-3 mb-3">
				<p class="mb-2 text-center">お問い合わせはメールでお願いいたします。</p>
				<div class="fl j-c">
					<a href="mailto:{contact_mail_address}">
						<div class="to-email text{add_prefix}-primary fl cl">
							<EmailArrowRight size="3em" />
							<span>Email</span>
						</div>
					</a>
				</div>
			</div>
		{/if}
	</div>
</MainLayout>

<style lang="scss" scoped>
	@use '../sass/color.scss' as color;
	.home-wrapper {
		padding-top: 1rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.inputter {
			flex-shrink: 0;
			flex-grow: 1;
			// width: 48%;
			.top-message {
				font-weight: bold;
				font-size: 0.9rem;
			}
			section.card {
				border-color: #ddd;
				border-radius: 0.3rem;
				&.vehicle-confirm-card {
					position: relative;
					&.search-successed {
						border-color: color.$teal;
					}
				}
				&.parts-search-card {
					position: relative;
					.search {
						width: 100%;
						button {
							width: 100%;
						}
					}
				}
				&.active-section {
					border-color: color.$alt-sea;
					border-width: 2px;
				}
				.form-group {
					text-align: left;
					.validation-hint,
					.input-group {
						max-width: 400px;
					}
					.input-group {
						.form-select {
							width: 130px;
							flex-grow: 0;
						}
					}
					.form-input {
						&.vin-input,
						&.item-code-input {
							ime-mode: disabled;
							text-transform: uppercase;
						}
					}
					.search-history {
						// max-width: 350px;
						.search-history-tags {
							display: flex;
							text-overflow: ellipsis;
							overflow: hidden;
							span {
								flex-shrink: 0;
							}
						}
					}

					&.search {
						width: auto;
						// max-width: 400px;
						button {
							height: 35px;
							&.plus {
								width: auto;
							}
							&.search {
								width: 60%;
							}
						}
					}
					&.item-code {
						width: 100%;
						li {
							border-bottom: solid 1px gray;
							padding-bottom: 0.2rem;
							.item-code-input-row {
								width: 90%;
								align-items: center;
								input {
									width: 100px;
								}
							}
						}
					}
				}
			}
		}
		.original-divider {
			width: 0.05rem;
			margin: 0 10px;
			border: 0.05rem solid #f1f3f5;
		}
		.result-and-info {
			position: relative;
			// width: 48%;
			flex-grow: 1;
			.result {
				.icon-result {
					b {
						font-size: 2rem;
					}
				}

				.result-card {
					position: relative;
					width: 100%;
					border-color: color.$light;

					.card-body {
						.adapted-info {
							text-decoration: underline;
							b {
								text-decoration: underline;
							}
						}
					}

					&.active-section {
						border-color: color.$alt-sea;
						border-width: 2px;
					}

					&.adapted-card {
						border-color: color.$teal;
						border-width: 2px;
					}

					&.non-adapted-card {
						border-color: color.$sea;
						border-width: 2px;
					}
				}
			}

			.contact-info {
				.or {
					font-size: 0.9rem;
				}
			}
		}

		@media (max-width: 1000px) {
			flex-direction: column;
			.inputter {
				width: auto;
				.card {
					.card-header {
						flex-direction: column;
						.actions {
							align-self: flex-end;
						}
					}
				}
			}
			.original-divider {
				width: auto;
				height: 0.05rem;
				margin: 10px 0;
			}
			.result-and-info {
				width: auto;
				// .result {
				// }
				.contact-info {
					position: relative;
					bottom: unset;
					right: unset;
				}
			}

			.pc-only {
				display: none;
			}
		}
	}
</style>
